import { createAuthProvider } from '@avantia/azure-ad-auth';
import { configureDataDogRum } from '@avantia/third-party-monitoring/configureDataDogRum';
import { MsalProvider } from '@azure/msal-react';
import jQuery from 'jquery';
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from 'react-redux';

import { setAgentSearchParams } from 'storage/agentSearch';
import { isAgentLogin } from 'utils';
import './assets/style/site.scss';
import App from './components/app';
import { getConfig } from './config/configuration';
import { registerClientConfig } from './config/registerClientConfig';
import { registerCustomIcons } from './registerCustomIcons';
import reportWebVitals from './reportWebVitals';
import store from './store/configureStore';

declare const window: any;
window.jQuery = window.jQuery || jQuery;
window.$ = window.jQuery;

const config = getConfig();
registerClientConfig(config);

const {
  azureAdClientId,
  azureAdTenantId,
  ddApplicationId,
  ddClientToken,
  ddCompressInTakeRequests,
  ddRumEnabled,
  ddRumSessionRecordingEnabled,
  ddServiceName,
  ddSessionReplaySampleRate,
  ddUsePartitionedCrossSiteSessionCookie,
  environment,
  releaseVersion,
  websiteBaseUrl
} = config;

configureDataDogRum({
  ddAllowedTracingUrls: [websiteBaseUrl],
  ddApplicationId,
  ddClientToken,
  ddCompressInTakeRequests,
  ddRumEnabled,
  ddRumSessionRecordingEnabled,
  ddServiceName,
  ddSessionReplaySampleRate,
  ddUsePartitionedCrossSiteSessionCookie,
  environment,
  releaseVersion,
  ddDefaultPrivacyLevel: 'mask-user-input'
});

// Submodules can't import svg components, so we need to do so here.
registerCustomIcons();

const authProvider = createAuthProvider({
  clientId: azureAdClientId,
  tenantId: azureAdTenantId,
  websiteBaseUrl
});

const { search } = window.location;
if (search) {
  setAgentSearchParams(search);
}

const renderWithAd = isAgentLogin();
const container = document.getElementById('root') as HTMLElement;
const root = ReactDOMClient.createRoot(container);

const appElement = (
  <Provider store={store}>
    <App />
  </Provider>
);

if (renderWithAd) {
  root.render(<MsalProvider instance={authProvider}>{appElement}</MsalProvider>);
} else {
  root.render(appElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
